/* eslint-disable */
import React, { useEffect, useState, useReducer } from "react";
import "./InvoiceMarkedPopup.scss";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from 'react-router-dom';
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import { Link } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import { Avatar, useMediaQuery } from "@material-ui/core";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { RootState } from "../../store/reducers"; 
import BookingSvg from "../../assets/images/Booking1.svg"
import scan from "../../assets/images/scan.svg"
function InvoiceMarkedPopup() {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const {token, loggedIn,stateUrlToken,langValue } = useSelector((state: RootState) => state.waiter);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const {
    freezScreenState,
    alertMessageState,
    setLoginState,
    branchState, setLogOut,
    setInvoiceMarkedpopup
  } = bindActionCreators(actionCreators, dispatch);
  const matches = useMediaQuery("(min-width:1200px)");


  
  const handeScanNewQrcode = ()=>{
    navigate("/scan-qr-code")
    setInvoiceMarkedpopup(true)
    
  }

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
        open={true}
        className="payTableBackdrop"
       
      />

      <div
        id="mySidenav"
        className={`InvoiceMarkedPopup offset-sm-0 col-12 offset-lg-3 col-lg-6 pb-3  ${
          langValue == "ar" ? "ArabicPayTablePopUp" : " "
        }`}
      >
  
        <div className="container-fluid content px-4 mt-5">
          <div className="row mt-3 px-2">
            <img src={BookingSvg} alt="BookingSvg" height={200} />
          {/* <h1
                      className={`d-flex familysora600 my-3 text-capitalize ${
                        langValue === "ar" ? "text-right" : "text-left"
                      }`}
                    >
           booking mark as completed !
                    </h1> */}
            <Button
            onClick={()=>handeScanNewQrcode()}
              className={`py-3 px-4 mt-3 payBillBtn  d-flex justify-content-center ${
                langValue === "ar" ? " familyGraphikArabic600 " : ""
              }`}
            >
              <img src={scan} alt="scan"  />
              <span className="mx-2"> SCAN NEW QR CODE </span>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(InvoiceMarkedPopup);
